import { IBrandCategory } from "../../../Models/IBrandCategory";
import { MarketPresenceOptions, SquareFootageOptions, UnitsAndGrowthOptions } from "../Models/Requests/IVoidGapRequest";

export type VoidGapFilterUnion = string[] | MarketPresenceOptions | SquareFootageOptions | UnitsAndGrowthOptions;

export type VoidGapFilterMap = {[key: string] : VoidGapFilterUnion};